import axios from "../httpClient";

export function getPKORefundChargebackReportApi(params = {}) {
  return axios.get("/report/pko/refund-chargeback-transitions", {
    params,
  });
}
